import { install } from "./lifecycle.js";
install();
//# sourceMappingURL=entry.js.map